/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum KeyPhysicalTargetTimeScale {
    Day = 0,
    Week = 1,
    Month = 2,
    Project = 3,
}
